import { Spinner } from '@platform/ui/components/spinner';
import { cn } from '@platform/ui/lib/utils';

/** A screen still loading: the spinner in the middle of the room the content will take, announced once. */
export function LoadingState({ label, className }: { label: string; className?: string }) {
    return (
        <div data-slot="loading-state" role="status" className={cn('grid min-h-[60dvh] place-items-center text-muted-foreground', className)}>
            <Spinner label={label} />
        </div>
    );
}
